<template>
  <div class="layout">
    <div class="error-404">
      <img src="images/err-404.png" class="error-404-img" />
      <div class="error-404-text">Расчет не найден.</div>
      <div class="d-flex flex-column justify-content-center align-items-center">
        <div class="error-404-link">
          <router-link to="/">Вернуться к списку расчетов</router-link>
        </div>
        <div class="error-404-link mt-2">
          <router-link to="/calculation">Создать новый расчет</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "calculation-error-404",
  methods: {
    openCalculationsList() {
      window.open("/", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.error-404 {
  overflow: hidden;
  background-position: top center;
  background-repeat: no-repeat;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-top: 30px;

  &-img {
    @media screen and (max-width: 500px) {
      width: 100%;
    }
  }

  &-text {
    padding-top: 38px;
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: 700;

    @media screen and (max-width: 500px) {
      padding-top: 30px;
      font-size: 22px;
    }
  }
}
</style>
